import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
  providedIn: 'root'
})
export class ApiSchoolDistrictsService extends BaseRestApiService {

 constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    public Create(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.systemSchoolDistrictsCreate,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

// Parties Search
    public getPartyContactMechanisms(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.parties_getPartyContactMechanisms,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public getContactMechanismPurposeTypes(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.parties_getContactMechanismPurposeTypes,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public getPartyRoleTypeByCategory(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.parties_getPartyRoleTypeByCategory,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    // Schools Search
    public getAllSchools(data: any): Observable<any> {
        const url = this.urlProvider.getUrl(EndPoints.schools, undefined, undefined, undefined);
        return this.post<any>(
            EndPoints.schools,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public getSpecificSchoolDistricts(data: any): Observable<any> {
    
        return this.post<any>(
            EndPoints.systemSchoolSearchDistricts,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }
    
    public getSpecificSchoolsShow(data: any): Observable<any> {
    
        return this.post<any>(
            EndPoints.systemSchoolDistrictShow,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public show(thisSchoolDistrictId: number) : Observable<any> {
        return this.get<any>(EndPoints.systemSchoolDistrictShow,
            {"id": thisSchoolDistrictId},
            );    
    }

    // Query Schools for autocomplete
    public searchSchoolDistricts(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.schoolDistricts,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    public getUserSchoolDistricts() : Observable<any> { //thisSchoolId: number
        return this.get<any>(EndPoints.schoolShow            
            );     // , {"id": thisSchoolId}
    }


    // Query Schools for Other School Types
    checkSchoolCode(value: number, schoolID: number): Observable<any> {
        return this.post<any>(
            EndPoints.schoolCheckCode,
            false,
            '',
            {"value": value, "schoolID": schoolID},
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    checkDistrictNCES(value: number, schoolID?: number): Observable<any> {
        return this.post<any>(
            EndPoints.schoolCheckNCESDistrictCode,
            false,
            '',
            {"value": value, "schoolID": schoolID},
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    // Query Schools for Save/Updates on Edit Schools 
    public updateSchoolDistrictsGeneralInfo(data: any): Observable<any> {
        console.log("calling updateSchoolGeneralInfo in API schools");
        console.log("with data")
        console.log(data)
        return this.post<any>(
            EndPoints.schoolDistrictsUpdateGeneralInfo,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }
    
 
    public updateSchoolDistrictsLocation(data: any): Observable<any> {

        return this.post<any>(
            EndPoints.schoolDistrictsUpdateLocation,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }
}


